import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
  category: string;
  tags: string;
}
interface DataCatTagStruc {
  id: number;
  slug: string;
  name: string;
}
const DashboardHome = () => {
  const api = process.env.REACT_APP_API_URL as string;

  const [newsData, setNewsData] = useState<NewsStructure[]>([]);
  const [allNews, setAllNews] = useState<NewsStructure[]>([]);

  const [categories, setCategories] = useState<DataCatTagStruc[]>([]);
  const [tags, setTags] = useState<DataCatTagStruc[]>([]);

  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [activeTag, setActiveTag] = useState<string | null>(null);

  // Fetch all data
useEffect(() => {
  const fetchAll = async () => {
    try {
      const [newsRes, catRes, tagRes] = await Promise.all([
        axios.get(`${api}/auth/news`),
        axios.get(`${api}/auth/category`),
        axios.get(`${api}/auth/tags`)
      ]);

      // Convert tags from comma string to array
    const cleanedNews = newsRes.data.map((item: any) => ({
  ...item,
  tags: typeof item.tags === 'string'
    ? item.tags.split('&').map((tag: string) => tag.trim())
    : [],
  category: typeof item.category === 'string'
    ? item.category.split('&').map((cat: string) => cat.trim())
    : [],
}));

      setAllNews(cleanedNews);
      setNewsData(cleanedNews);
      setCategories(catRes.data);
      setTags(tagRes.data);
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  fetchAll();
}, [api]);


  // Filter logic
  const filterNews = (category: string | null, tag: string | null) => {
    let filtered = [...allNews];
    if (category) {
      filtered = filtered.filter((n) => n.category === category);
    }
    if (tag) {
      filtered = filtered.filter((n) => n.tags.includes(tag));
    }
    setNewsData(filtered);
  };

  // Handlers
  const handleCategoryClick = (cat: string | null) => {
    const newCategory = cat === activeCategory ? null : cat;
    setActiveCategory(newCategory);
    filterNews(newCategory, activeTag);
  };

  const handleTagClick = (tag: string | null) => {
    const newTag = tag === activeTag ? null : tag;
    setActiveTag(newTag);
    filterNews(activeCategory, newTag);
  };

  return (
    <div className="container mx-auto p-6 space-y-8">
      <h1 className="text-3xl font-bold">News Dashboard</h1>

      {/* Categories */}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => handleCategoryClick(null)}
          className={`px-4 py-1 rounded-full border ${activeCategory === null ? 'bg-black text-white' : 'bg-white text-black border-gray-400'} transition`}
        >
          All Categories
        </button>
        {categories.map((cat) => (
          <button
            key={cat.name}
            onClick={() => handleCategoryClick(cat.name)}
            className={`px-4 py-1 rounded-full border ${activeCategory === cat.name ? 'bg-blue-600 text-white' : 'bg-white text-blue-600 border-blue-600'} transition`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* Tags */}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => handleTagClick(null)}
          className={`px-3 py-1 rounded-lg border ${activeTag === null ? 'bg-black text-white' : 'bg-white text-black border-gray-400'} transition`}
        >
          All Tags
        </button>
        {tags.map((tag) => (
          <button
            key={tag.name}
            onClick={() => handleTagClick(tag.name)}
            className={`px-3 py-1 rounded-lg border ${activeTag === tag.name ? 'bg-green-600 text-white' : 'bg-white text-green-600 border-green-600'} transition`}
          >
            #{tag.name}
          </button>
        ))}
      </div>

      {/* News Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {newsData.map((news) => (
          <div
            key={news.id}
            className="bg-white rounded-lg shadow-md hover:shadow-xl transition overflow-hidden"
          >
            <img
              src={`${api}/${news.img}`}
              alt={news.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 space-y-2">
              <h2 className="text-xl font-semibold">{news.title}</h2>
              <p className="text-sm text-gray-600">{news.content}</p>
              <div className="flex flex-wrap gap-1 text-xs text-gray-500">
                <span className="bg-gray-200 px-2 py-0.5 rounded">{news.category}</span>
                {typeof news.tags === 'string' &&
  news.tags.split('&').map((tag, index) => (
    <span key={index} className="bg-gray-100 px-2 py-0.5 rounded mr-1">
      #{tag.trim()}
    </span>
))}

              </div>
            </div>
          </div>
        ))}
      </div>

      {newsData.length === 0 && (
        <p className="text-gray-500 text-center">No news found for selected filters.</p>
      )}
    </div>
  );
};

export default DashboardHome;
